import { useRef, useEffect } from 'react';
import './list-item.scss';

interface ListItemProps {
  active: boolean;
  onClickItem: (text: string) => void;
  text: string;
}

const ListItem = ({ active, onClickItem, text }: ListItemProps) => {
  const handleOnClick = () => onClickItem(text);
  const itemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (active && itemRef && itemRef.current) {
      itemRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [active, text])

  return (
    <div
      ref={itemRef}
      className={`glu-search-item${active ? ' glu-search-item--active' : ''}`}
      onClick={handleOnClick}
    >
      {text}
    </div>
  );
};

export default ListItem;